export default "__VITE_ASSET__DR7IUHl8__"